import { Pagination } from "../../../../components/design-system";

import { useIsCompact } from "./CardDensity";

/**
 * Table pagination, with V3's chevron treatment.
 *
 * The shared Pagination draws prev/next as bare glyphs. V3 boxes them the way
 * the store-type chart's month arrows are boxed — 32px bordered square, gray
 * fill and gray glyph when there's nowhere to go — so the two kinds of stepper
 * on a page read as the same control. Scoped through a wrapper rather than by
 * editing the shared component, which other prototypes render.
 *
 * V1/V2 keep the shared styling.
 */
const CHEVRON_BUTTON_CLASSES = [
  "[&>nav>button]:size-8",
  "[&>nav>button]:rounded",
  "[&>nav>button]:border",
  "[&>nav>button]:border-[#dfe0e1]",
  "[&>nav>button]:text-[#333]",
  "[&>nav>button:disabled]:bg-[#f7f7f7]",
  "[&>nav>button:disabled]:text-[#b3b3b3]",
].join(" ");

export function TablePagination({
  currentPage,
  totalPages,
  onClick,
}: {
  currentPage: number;
  totalPages: number;
  onClick: (page: number) => void;
}) {
  const isCompact = useIsCompact();

  return (
    <div className={isCompact ? CHEVRON_BUTTON_CLASSES : undefined}>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onClick={onClick}
      />
    </div>
  );
}
